import { Injectable } from '@angular/core'
import Color from 'color'

@Injectable({
  providedIn: 'root',
})
export class GbColorService {
  public darkText = '#000000DE'
  public lightText = '#FFFFFFDE'

  private readonly WCAG_MIN_CONTRAST = 4.5

  /**
   * Gets the contrast to a given colour
   * @param inputColor colour to get the contrast to
   **/
  getContrast(inputColor: string): string {
    try {
      const color = Color(inputColor)
      return color.isLight() ? this.darkText : this.lightText
    } catch (error) {
      return this.darkText
    }
  }

  /**
   * Returns true if two-color pairings meet or exceed
   * the WCAG AA contrast standard (4.5:1).
   */
  isContrasting(color1: string, color2: string): boolean {
    if (!color1 || !color2) return false

    try {
      return Color(color1).contrast(Color(color2)) >= this.WCAG_MIN_CONTRAST
    } catch (error) {
      return false
    }
  }
}
